﻿define([
	'pubsub', 'addressService'],

	function (pubsub) {
		'use strict';

		var module = {};
		module.private = {};

		module.geoCodeAddress = function (address) {
			var geoCodeDeferred;

			//create a promise for the google geocode request
			geoCodeDeferred = Q.defer();

			//request the geocode
			pubsub.publish('uiWantsGeoCodeAddress', {
				'address': address,
				'deferred': geoCodeDeferred
			});

			return geoCodeDeferred.promise;
		};

		//geocodepoint
		module.geoCodePoint = function (latitude, longtitude) {
			var geoCodeDeferred;

			//create a promise for the google geocode request
			geoCodeDeferred = Q.defer();

			//request the geocode
			pubsub.publish('uiNeeds.GeoCodePoint', {
				'location': {
					lat: latitude,
					lng: longtitude
				},
				'deferred': geoCodeDeferred
			});

			return geoCodeDeferred.promise;
		};

		module.private.handleDataGeoCode = function (e, data) {
			var action;

			//select how to resolve the promise based on the status
			action = (data.response.status === '200') ? 'resolve' : 'reject';

			//resolve the promise
			data.request.deferred[action](data);
		};

		pubsub.subscribe('dataGeoCodeAddress', module.private.handleDataGeoCode);
		return module;
		
	}
);